var e = {
  d: (s, t) => {
    for (var a in t) e.o(t, a) && !e.o(s, a) && Object.defineProperty(s, a, {
      enumerable: !0,
      get: t[a]
    });
  },
  o: (e, s) => Object.prototype.hasOwnProperty.call(e, s)
};
(() => {
  var s;
  if ("string" == typeof import.meta.url && (s = import.meta.url), !s) throw new Error("Automatic publicPath is not supported in this browser");
  s = s.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), e.p = s;
})();
var s = {};
e.d(s, {
  vs: () => u,
  U2: () => d,
  tc: () => r
});
const t = require("react/jsx-runtime"),
  a = require("uitk-react-icons"),
  o = require("uitk-react-utils"),
  c = e.p + "./styles/egds-trips-favorite-button.css",
  l = o.classNames.bind(c),
  r = e => {
    const {
        checked: s,
        accessibilityLabel: o,
        onClick: c,
        text: r,
        accentOutlineHighlighted: i
      } = e,
      n = ((e, s, t) => {
        const a = "favorite-button";
        return e ? {
          wrapperCssClassName: l(),
          buttonCssClassName: l(a, `${a}-button-with-label`, {
            [`${a}-button-is-checked`]: s
          }),
          fillCssClassName: l(`${a}-fill`, `${a}-fill-pill`),
          borderCssClassName: l(`${a}-border`, `${a}-border-pill`, t ? `${a}-border-color-highlighed` : `${a}-border-color-default`),
          textCssClassName: l(`${a}-text`)
        } : {
          wrapperCssClassName: l(`${a}-wrapper`),
          buttonCssClassName: l(a, `${a}-button-no-label`, {
            [`${a}-button-is-checked`]: s
          }),
          fillCssClassName: l(`${a}-fill`, `${a}-fill-default`),
          borderCssClassName: l(`${a}-border`, `${a}-border-default`, t ? `${a}-border-color-highlighed` : `${a}-border-color-default`)
        };
      })(Boolean(r), s, i);
    return (0, t.jsx)("div", {
      className: n.wrapperCssClassName,
      children: (0, t.jsxs)("button", {
        type: "button",
        onClick: c,
        "aria-label": o,
        className: n.buttonCssClassName,
        children: [(0, t.jsx)(a.UitkIcon, {
          name: "favorite",
          className: n.fillCssClassName
        }), (0, t.jsx)(a.UitkIcon, {
          name: "favorite_border",
          className: n.borderCssClassName
        }), r && (0, t.jsx)("span", {
          className: n.textCssClassName,
          children: r
        })]
      })
    });
  },
  i = e.p + "./styles/egds-trips-action-count.css",
  n = o.classNames.bind(i),
  u = e => {
    const {
      count: s,
      iconId: o,
      onClick: c,
      accessibilityLabel: l
    } = e;
    return (0, t.jsxs)("button", {
      type: "button",
      onClick: c,
      "aria-label": l,
      className: n("action-count-button"),
      children: [(0, t.jsx)(a.UitkIcon, {
        name: o,
        size: a.UitkIconSize.EXTRA_SMALL,
        className: n("action-count-icon")
      }), (0, t.jsx)("span", {
        className: n("action-count-text"),
        children: s
      })]
    });
  },
  b = o.classNames.bind(i),
  d = e => {
    const {
      checked: s,
      count: o,
      iconId: c,
      onClick: l,
      accessibilityLabel: r
    } = e;
    return (0, t.jsxs)("button", {
      type: "button",
      onClick: l,
      role: "checkbox",
      "aria-label": r,
      "aria-checked": s,
      className: b("action-count-button"),
      children: [(0, t.jsx)(a.UitkIcon, {
        name: c,
        size: a.UitkIconSize.EXTRA_SMALL,
        className: b(s ? "action-count-icon-checked" : "action-count-icon")
      }), (0, t.jsx)("span", {
        className: b("action-count-text"),
        children: o
      })]
    });
  };
var m = s.vs,
  C = s.U2,
  p = s.tc;
export { m as EGDSLocalActionCount, C as EGDSLocalActionCountToggle, p as EGDSLocalFavoriteButton };